import { useState, useRef, useEffect, useMemo } from 'react';
import './mapnavigation.css';
import markerbg from "./img/markerbg.png";

import closeicon from "./img/close.svg";
import closeiconwhite from "./img/close-white.svg";
import checkmark from "./img/checkmark.svg";
import locationicon from "./img/location.svg";
import icon_bell_on from "./img/bell-on.svg";
import icon_bell_off from "./img/bell-off.svg";
import mapstyleicon from "./img/map.svg";
import lockicon from "./img/lock-white.svg";
import detailStationIcon from "./img/detail-station.svg";


import PoiDot from './components/PoiDot';


import Map, { Marker, Popup, Source, Layer } from 'react-map-gl/maplibre';


import { translate } from './functions/translationHelper';

import { useParams, useNavigate } from 'react-router-dom';

import LoadingScreen from './LoadingScreen';

import StationImage from './components/StationImage';

import { handleApiResponse } from './functions/handleApiResponse.js';

import MapProgress from './components/MapProgress';

import PositionDot from './components/PositionDot';
import { applyTrailRouteVariant, readTrailRouteVariant } from './functions/trailRouteVariant.js';
import { useLoadingRecovery } from './functions/useLoadingRecovery';
import {
  applyLocalProgressToMapData,
  getMapSnapshotKey,
  getOfflineAwareJson,
} from './functions/offlineStore';

import ModalStationProgress from './components/ModalStationProgress';
import ModalLocationInfo from './components/ModalLocationInfo';



import sound from "./img/sounds/bell.mp3";
import soundsilence from "./img/sounds/silence.mp3";
import LoadingClouds from './components/LoadingClouds.js';
import NotificationProvider from './components/NotificationProvider.js';
import BigNotification from './components/BigNotification.js';

const STATION_UNLOCK_RADIUS_METERS = 20;
const STATION_RADIUS_FADE_START_METERS = 60;
const STATION_RADIUS_FULL_OPACITY_METERS = 40;
const LOW_LOCATION_ACCURACY_THRESHOLD_METERS = 100;
const LOW_LOCATION_ACCURACY_REQUIRED_READINGS = 3;
const LOW_LOCATION_ACCURACY_NOTIFICATION_COOLDOWN_MS = 60 * 1000;
const EARTH_RADIUS_METERS = 6371e3;
const GEOLOCATION_OPTIONS = { enableHighAccuracy: true };

const stationRadiusFillLayer = {
  id: 'station-unlock-radius-fill',
  type: 'fill',
  paint: {
    'fill-color': [
      'case',

      ['boolean', ['get', 'done'], false],
      '#4CA87000',
      '#0066FF',
    ],
    'fill-opacity': ['*', ['get', 'radiusOpacity'], 0.04],
  },
};

const stationRadiusLineLayer = {
  id: 'station-unlock-radius-line',
  type: 'line',

  layout: {
    'line-cap': 'round',
    'line-join': 'round',
  },

  paint: {
    'line-color': [
      'case',
      ['boolean', ['get', 'done'], false],
      '#4CA87000',
      '#0066FF',
    ],

    'line-opacity': ['*', ['get', 'radiusOpacity'], 0.2],

    'line-width': 2,

    'line-dasharray': [0.1, 2],
  },
};

function getStationRadiusOpacity(distanceMeters) {
  if (!Number.isFinite(distanceMeters) || distanceMeters >= STATION_RADIUS_FADE_START_METERS) {
    return 0;
  }

  if (distanceMeters <= STATION_RADIUS_FULL_OPACITY_METERS) {
    return 1;
  }

  return (STATION_RADIUS_FADE_START_METERS - distanceMeters) /
    (STATION_RADIUS_FADE_START_METERS - STATION_RADIUS_FULL_OPACITY_METERS);
}

function createRadiusCircleFeature(station, index, radiusOpacity, radiusMeters = STATION_UNLOCK_RADIUS_METERS, pointCount = 64) {
  const latitude = Number(station.lat);
  const longitude = Number(station.long);

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return null;
  }

  const angularDistance = radiusMeters / EARTH_RADIUS_METERS;
  const centerLat = latitude * Math.PI / 180;
  const centerLng = longitude * Math.PI / 180;
  const coordinates = [];

  for (let i = 0; i <= pointCount; i += 1) {
    const bearing = (i / pointCount) * 2 * Math.PI;
    const pointLat = Math.asin(
      Math.sin(centerLat) * Math.cos(angularDistance) +
      Math.cos(centerLat) * Math.sin(angularDistance) * Math.cos(bearing)
    );
    const pointLng = centerLng + Math.atan2(
      Math.sin(bearing) * Math.sin(angularDistance) * Math.cos(centerLat),
      Math.cos(angularDistance) - Math.sin(centerLat) * Math.sin(pointLat)
    );

    coordinates.push([pointLng * 180 / Math.PI, pointLat * 180 / Math.PI]);
  }

  return {
    type: 'Feature',
    properties: {
      stationIndex: index,
      radiusOpacity,
      done: Boolean(station.done),
    },
    geometry: {
      type: 'Polygon',
      coordinates: [coordinates],
    },
  };
}

function isBrowserOffline() {
  return typeof navigator !== 'undefined' && navigator.onLine === false;
}

function MapNavigation() {

  let { regionid, trailid } = useParams();
  const navigate = useNavigate();

  const shouldShowNoLocationNotification = !(localStorage.getItem("devmode") == "1" || regionid === "demo");

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const { needsManualReload, reloadNow, triggerRecovery } = useLoadingRecovery({
    active: loading,
  });

  const [maploaded, setMaploaded] = useState(false);

  const mapref = useRef(null);

  const [currentpoi, setcurrentpoi] = useState(-1);
  const [stationopen, setstationopen] = useState(false);
  const [currentstation, setcurrentstation] = useState(0);

  const [currentposition, setcurrentposition] = useState(null);
  const [stationdistances, setstationdistances] = useState([]);
  const [orientationAngle, setOrientationAngle] = useState(null);

  const [geojson, setgeojson] = useState(null);



  const [badgemode, setBadgemode] = useState({ mode: "end" });

  const [viewport, setViewport] = useState({
    latitude: 47.269200,
    longitude: 11.404100,
    zoom: 10,
  });

  const [notifications, setNotifications] = useState([]);

  const [currentNotification, setCurrentNotification] = useState(null);
  const [bigNotification, setBigNotification] = useState(null);

  const [stationprogressmodalopen, setstationprogressmodalopen] = useState(false);
  const [locationinfomodalopen, setlocationinfomodalopen] = useState(false);

  const [hasArrived, setHasArrived] = useState(false);

  const [useSatellite, setUseSatellite] = useState(localStorage.getItem("useSatellite") == 1 || false);
  const activeMapStyle = useSatellite && !isBrowserOffline() ? "satellite" : "streets";

  const [useSound, setUseSound] = useState(true);

  const [stationZ, setStationZ] = useState([]);
  const poiTooltipZIndex = (data?.stations?.length ?? 0) + 1;
  const isDevMode = process.env.NODE_ENV === 'development' || localStorage.getItem("devmode") == 1;

  const soundRef = useRef(null);
  const customSoundRef = useRef(null);
  const testSoundRef = useRef(null);
  const locationWatchIdRef = useRef(null);
  const locationAccuracyRef = useRef({
    lowAccuracyReadings: 0,
    lastNotificationAt: 0,
  });


  function recomputeStationZ() {
  const map = mapref.current;
  if (!map || !data?.stations?.length) return;

  // project each station to screen space
  const projected = data.stations.map((s, idx) => {
    const p = map.project([s.long, s.lat]); // MapLibre GL JS: {x,y}
    return { idx, y: p.y };
  });

  // sort by y ascending (top first, bottom last)
  projected.sort((a, b) => a.y - b.y);

  // assign increasing z; bottom-most gets highest z
  const z = new Array(data.stations.length);
  projected.forEach((item, rank) => {
    z[item.idx] = rank;
  });

  setStationZ(z);
  console.log("New projection:" + z);
}

useEffect(() => {
  const map = mapref.current;
  if (!map || !data?.stations?.length) return;

  const handler = () => recomputeStationZ();

  
  map.on('rotateend', handler);  // after rotation (final)

  // optional: if users pitch a lot and you want to be ultra-safe
  // map.on('pitch', handler);
  map.on('pitchend', handler);

  handler(); // initial compute

  return () => {
    map.off('rotateend', handler);
    // map.off('pitch', handler);
    map.off('pitchend', handler);
  };
}, [data?.stations, mapref.current]);
  const badgePosition = useMemo(() => {
    if (data.stations != undefined) {
      if (badgemode?.mode == "roundtrip") {
        return [data.stations[0].lat, data.stations[0].long];
      } else if (badgemode?.mode == "custom") {
        return [badgemode.position.lat, badgemode.position.long];
      } else {
        return [data.stations[data.stations.length - 1].lat, data.stations[data.stations.length - 1].long];
      }
    }
  }, [data]);

  const stationRadiusGeoJson = useMemo(() => {
    if (!data?.stations?.length) {
      return null;
    }

    const features = data.stations
      .map((station, index) => {
        const stationDistance = stationdistances[index];
        const showRadius = !station.done &&
          Number.isFinite(stationDistance) &&
          stationDistance <= STATION_RADIUS_FADE_START_METERS;

        if (!showRadius) {
          return null;
        }

        return createRadiusCircleFeature(station, index, getStationRadiusOpacity(stationDistance));
      })
      .filter(Boolean);

    if (!features.length) {
      return null;
    }

    return {
      type: 'FeatureCollection',
      features,
    };
  }, [data?.stations, stationdistances]);


  function addNotification(template) {
    let findnotification = notifications.findIndex(notification => notification.template === template);
    if (findnotification == -1) {
      setNotifications(items => [...items, { template: template }])
    }
  }

  function removeNotification(index) {
    let temp = [...notifications];
    temp.splice(index, 1);
    setNotifications(temp)
  }

  function handleFlyTo(index) {
    /*
    const newViewport = {
      ...viewport,
      latitude: parseFloat(data.stations[index].lat),
      longitude: parseFloat(data.stations[index].long),
      zoom: 12,
      transitionInterpolator: new FlyToInterpolator(),
      transitionDuration: 2000,
    };
  
    setViewport(newViewport);*/
    mapref.current?.flyTo({ center: [data.stations[index].long, data.stations[index].lat], zoom: 16 });
  }

  function flytoCurrentPosition() {
    mapref.current?.flyTo({ center: [currentposition[1], currentposition[0]], zoom: 16 });
  }


  function toggletooltip(index) {
    setstationopen(false);
    if (index == currentpoi) {
      setcurrentpoi(-1);
    } else {
      setcurrentpoi(index)
    }
  }

  function togglestation(index) {
    setcurrentpoi(-1);
    setstationprogressmodalopen(false);
    if (index == currentstation && stationopen) {
      setstationopen(false);
    } else {
      handleFlyTo(index);
      setcurrentstation(index);
      setstationopen(true)
    }
    //mapref.current?.flyTo({center: [data[index]?.long, data[index]?.lat], transitionDuration: 3000})
  }

  function openstationpopup(index) {
    handleFlyTo(index);
    setcurrentstation(index);
    setstationopen(true)
  }

  useEffect(() => {
    fetchData();
    fetchgeojson();
  }, []);

  useEffect(() => {
    const handleOffline = () => setUseSatellite(false);

    window.addEventListener('offline', handleOffline);

    if (isBrowserOffline()) {
      handleOffline();
    }

    return () => window.removeEventListener('offline', handleOffline);
  }, []);

  useEffect(() => {
    let isMounted = true;

    navigator.permissions.query({ name: 'geolocation' }).then(result => {
      if (!isMounted) {
        return;
      }

      if (result.state === 'granted') {
        startWatchingLocation();
      } else if (result.state === 'denied') {
        // User explicitly denied — show the modal directly
        if (shouldShowNoLocationNotification) {
          setBigNotification("nolocation");
        }
      } else {
        // state is "prompt" — try to trigger permission via getCurrentPosition
        tryRequestLocationSilently(() => isMounted);
      }
    });

    return () => {
      isMounted = false;
      stopWatchingLocation();
    };
  }, []);

  function tryRequestLocationSilently(shouldUseResult = () => true) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        if (!shouldUseResult()) {
          return;
        }

        locationSuccess(position);
        startWatchingLocation();
      },
      (error) => {
        if (!shouldUseResult()) {
          return;
        }

        // This is where iOS Safari fails silently unless it's triggered via gesture
        if (shouldShowNoLocationNotification) {
          setBigNotification("nolocation");
        }
      },
      GEOLOCATION_OPTIONS
    );
  }

  function handleRequestLocation() {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        locationSuccess(position);
        startWatchingLocation(); // This will now work
        setBigNotification(null);
      },
      (error) => {
        setlocationinfomodalopen(true);
        locationError(error);
      },
      GEOLOCATION_OPTIONS
    );
  }

  function startWatchingLocation() {
    if (!navigator.geolocation || locationWatchIdRef.current != null) {
      return;
    }

    locationWatchIdRef.current = navigator.geolocation.watchPosition(
      locationSuccess,
      (error) => {
        if (error.code == 1) {
          stopWatchingLocation();
        }

        locationError(error);
      },
      GEOLOCATION_OPTIONS
    );
  }

  function stopWatchingLocation() {
    if (!navigator.geolocation || locationWatchIdRef.current == null) {
      return;
    }

    navigator.geolocation.clearWatch(locationWatchIdRef.current);
    locationWatchIdRef.current = null;
  }

  useEffect(() => {
    if (data?.language && !isBrowserOffline()) {

      soundRef.current = new Audio(sound);


      // 1) Create an Audio object for the custom sound
      const customAudio = new Audio(`${process.env.REACT_APP_CONTENT_URL}${regionid}/${trailid}/sound-${data.language}.mp3`);

      customSoundRef.current = customAudio;
      // 2) If there's a loading error (e.g., 404, network error),
      //    switch to the fallback sound
      /*customAudio.onerror = () => {
        console.warn("Custom sound failed to load, falling back.");
        customSoundRef.current = new Audio(sound);
      };*/

      // 3) If it *can* load successfully, that's all we need
      //    (the onerror won't fire)


      // Optional: Force the browser to start loading
      //customAudio.load();

      // Test Audio permission
      testSoundRef.current = new Audio(soundsilence);
      testSoundRef.current?.play().catch(() => {
        setUseSound(false);
        console.log("sound false");
      });

    }
  }, [data]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_URL}getMap.php?region=${regionid}&trailid=${trailid}`;
      const data = await getOfflineAwareJson({
        key: getMapSnapshotKey(regionid, trailid, localStorage.getItem("language") || "en"),
        url,
        options: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('uuid')}`,
        }
        },
      });
      console.log(data);
      if (data.code !== undefined) {
        handleApiResponse(data.code, regionid, navigate);
      } else {
        const dataWithLocalProgress = await applyLocalProgressToMapData(data, regionid, trailid);
        const routeVariant = readTrailRouteVariant(trailid);
        const transformedData = {
          ...dataWithLocalProgress,
          stations: applyTrailRouteVariant(dataWithLocalProgress.stations, routeVariant),
        };

        setData(transformedData);
        let newbadgemode = JSON.parse(dataWithLocalProgress.badgemode || "null");
        //console.log(newbadgemode);
        if (newbadgemode?.mode !== undefined) {
          setBadgemode(newbadgemode);
        }
        if (transformedData.stations.every(station => station.done)) {
          navigate(`/${regionid}/success/${trailid}`);
          /*
          setCollectbadgemode(true);
          addNotification("done");
          // wenn Devmode, geh direkt zum Badge
          if(localStorage.getItem("devmode") == 1) {
            navigate(`/${regionid}/success/${trailid}`);
          }*/
        };

        let nextstation = transformedData.stations.findIndex(station => station.done === false);
        let donestations = transformedData.stations.filter(station => station.done);

        if (donestations.length == 0) {
          setTimeout(() => setCurrentNotification("letsgo"), 2500);
        }

        if (donestations.length == transformedData.stations.length - 1) {
          setTimeout(() => setCurrentNotification("laststation"), 2500);
        }

        if (nextstation >= 0) {
          setViewport({
            latitude: transformedData.stations[nextstation].lat,
            longitude: transformedData.stations[nextstation].long,
            zoom: 11
          });
        } else {
          setViewport({
            latitude: transformedData.stations[transformedData.stations.length - 1].lat,
            longitude: transformedData.stations[transformedData.stations.length - 1].long,
            zoom: 11
          });
        }
        setLoading(false);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      triggerRecovery();
    }
  };


  function initialzoom() {
    const stations = data?.stations || [];
    let nextstation = stations.findIndex(station => station.done === false);
    const targetStation = stations[nextstation >= 0 ? nextstation : stations.length - 1];

    if (targetStation && mapref?.current) {
      mapref.current.flyTo({ center: [targetStation.long, targetStation.lat], zoom: 16, speed: 0.5 });
    }

    setMaploaded(true);

  }

  function handleMapError(error) {
    console.warn('Map resource error:', error?.error || error);

    if (!maploaded) {
      initialzoom();
    }
  }

  const fetchgeojson = async () => {
    fetch(
      `${process.env.REACT_APP_CONTENT_URL}${regionid}/${trailid}/route.geojson`
    )
      .then(resp => resp.json())
      .then(json => setgeojson(json))
      .catch(err => console.error('Could not load data', err)); // eslint-disable-line
  };

  const lineStyle = {
    id: 'line',
    type: 'line',
    paint: {
      "line-color": "#71A8FB",
      "line-width": 5,
    },
    layout: {
      "line-cap": "round"
    }
  };



  // location fetched successfully
  function locationSuccess(position) {
    console.log(position.coords);
    setBigNotification(null);
    handleLocationAccuracy(position.coords.accuracy);
    setcurrentposition([position.coords.latitude, position.coords.longitude]);
  }

  function handleLocationAccuracy(accuracy) {
    const numericAccuracy = Number(accuracy);

    if (!Number.isFinite(numericAccuracy)) {
      return;
    }

    if (numericAccuracy <= LOW_LOCATION_ACCURACY_THRESHOLD_METERS) {
      locationAccuracyRef.current.lowAccuracyReadings = 0;
      return;
    }

    locationAccuracyRef.current.lowAccuracyReadings += 1;

    if (locationAccuracyRef.current.lowAccuracyReadings < LOW_LOCATION_ACCURACY_REQUIRED_READINGS) {
      return;
    }

    const now = Date.now();
    if (now - locationAccuracyRef.current.lastNotificationAt < LOW_LOCATION_ACCURACY_NOTIFICATION_COOLDOWN_MS) {
      return;
    }

    locationAccuracyRef.current.lastNotificationAt = now;
    setCurrentNotification("lowlocationaccuracy");
  }

  // location fetching failed
  function locationError(error) {
    if (error.code == 1) {
      if (shouldShowNoLocationNotification) {
        setBigNotification("nolocation");
      }
    }
    console.log("Error Code: " + error.code);
    console.log("Error Message: " + error.message);
  }

  function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371e3; // Earth radius in meters
    const phi1 = (lat1 * Math.PI) / 180;
    const phi2 = (lat2 * Math.PI) / 180;
    const deltaPhi = ((lat2 - lat1) * Math.PI) / 180;
    const deltaLambda = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
      Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = Math.round(R * c); // Distance in meters rounded to the nearest integer
    return distance;
  }

  useEffect(() => {
    if (currentposition != null && data.stations != undefined) {
      const distances = data.stations.map(station =>
        calculateDistance(currentposition[0], currentposition[1], station.lat, station.long)
      );
      setstationdistances(distances);
      const withinRadiusIndex = distances.findIndex(distance => distance <= STATION_UNLOCK_RADIUS_METERS);

      if (withinRadiusIndex !== -1 && data.stations[withinRadiusIndex]?.done === false) {

        if (!hasArrived) {
          // Vibrate (only works on some devices/browsers)
          navigator?.vibrate?.(200);

          // Play sound
          if (useSound) {
            soundRef.current?.play();
            setTimeout(() => {
              const customAudio = customSoundRef.current;
              if (customAudio?.src && customAudio.readyState > 0) {
                customAudio.play().catch(() => {
                  console.warn("Custom sound couldn't play.");
                });
              } else {
                console.warn("Custom sound not loaded or missing source.");
              }
            }, 1200);
            //customSoundRef.current?.play().catch(() => soundRef.current?.play());
          }


          // Mark arrival so it doesn't repeat
          setHasArrived(true);

          openstationpopup(withinRadiusIndex);
        }
      } else {
        // If no station is in range, we reset hasArrived so
        // that we can detect a new arrival next time.
        if (hasArrived) {
          setHasArrived(false);
        }
      }
    }
  }, [currentposition])

  function openstationfancy(station) {
    setstationopen(false);
    mapref?.current?.flyTo({ center: [data.stations[station].long, data.stations[station].lat], zoom: 20, speed: 1 });
    const element = document.querySelector('#fancyfadeout');
    if (element) {
      element.style.display = 'block';
    }
    setTimeout(() => navigate(`/${regionid}/station/${data.stations[currentstation]?.stationid}`), 1300)
  }

  function canReplayStation(station) {
    return data?.done === true || station?.done === true;
  }

  function getStationButton() {
    const station = data.stations[currentstation];
    const stationDistance = stationdistances[currentstation];

    if (canReplayStation(station)) {
      return <div onClick={() => openstationfancy(currentstation)} className='openstationbtn openstationbtnactive clickable'>{translate("openagain", data.language)}</div>
      //return <div onClick={() => navigate(`/${regionid}/station/${data.stations[currentstation]?.stationid}`)} className='openstationbtn openstationbtnactive clickable'>{translate("openagain", data.language)}</div>
    }

    if (isDevMode || regionid === "demo") {
      return <div onClick={() => openstationfancy(currentstation)} className='openstationbtn openstationbtnactive clickable'>{translate("opennow", data.language)}</div>
    }

    if (currentposition != null) {
      if (stationDistance <= STATION_UNLOCK_RADIUS_METERS) {
        return <div onClick={() => openstationfancy(currentstation)} className='openstationbtn openstationbtnactive clickable'>{translate("opennow", data.language)}</div>
      } else {
        const lockedButtonText = Number.isFinite(stationDistance)
          ? translate("stationdistanceaway", data.language).replace('${1}', formatDistance(stationDistance))
          : translate("moveclosertounlock", data.language);

        return <div className='openstationbtn' style={{ backgroundColor: '#888' }}><img src={lockicon} />{lockedButtonText}</div>
      }
    } else {
      return <div className='openstationbtn' style={{ backgroundColor: '#888' }}>{translate("nolocation", data.language)}</div>
    }
  }

  function getStationLocationHint() {
    const locationHint = data.stations?.[currentstation]?.locationhint;

    if (
      typeof locationHint !== "string" ||
      locationHint.trim() === ""
    ) {
      return null;
    }

    return <div className='stationlocationhint'><strong>{translate("locationhintlabel", data.language)}</strong> {locationHint.trim()}</div>
  }

  /*
  function getBadgeTooltip() {
    if(currentposition && badgePosition) {
      console.log(currentposition);
      console.log(badgePosition);
      var badgedistance = calculateDistance(currentposition[0], currentposition[1], badgePosition[0], badgePosition[1]);
      if(badgedistance != undefined) {
        if(badgedistance <= 20) {
          return <div className={`stationbubble stationbubble-active`} style={{fontWeight: 'bold'}}>{translate("taptocollect", data.language)}</div>
        } else {
          return <div className={`stationbubble`}>{formatDistance(badgedistance - 20)}</div>
        } 
      } else {
        return currentposition == null && <div className={`stationbubble`}>{translate("nolocation", data.language)}</div>
      }
    } else {
      return <div className={`stationbubble`}>{translate("nolocation", data.language)}</div>
    }
  }*/


  function formatDistance(distance) {
    if (distance < 1000) {
      return `${distance} m`;
    } else {
      const distanceInKm = (distance / 1000).toFixed(1);
      return `${distanceInKm} km`;
    }
  }

  function handlenotificationclick(template, type) {
    if (template === "nolocation") {
      if (type === "primary") {
        handleRequestLocation();
      } else {
        setlocationinfomodalopen(true);
      }
    }

    if (template === "lowlocationaccuracy") {
      setlocationinfomodalopen(true);
    }
  }

  /*
  useEffect(() => {
    const handleOrientation = (event) => {
      const { alpha } = event; // alpha represents the compass direction
      setOrientationAngle(alpha);
      console.log(alpha);
    };

    if (window.DeviceOrientationEvent) {
      window.addEventListener("deviceorientation", handleOrientation, true);
    }

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("deviceorientation", handleOrientation, true);
    };
  }, []);
  */

  useEffect(() => {
    if (useSatellite && isBrowserOffline()) {
      setUseSatellite(false);
      return;
    }

    if (useSatellite) {
      localStorage.setItem("useSatellite", 1);
    } else {
      localStorage.setItem("useSatellite", 0);
    }
  }, [useSatellite]);

  function handleToggleMapStyle() {
    if (isBrowserOffline()) {
      setUseSatellite(false);
      return;
    }

    setUseSatellite(!useSatellite);
  }

  const handleToggleSound = () => {
    // Toggle the state
    setUseSound(prev => !prev);

    // If we are switching it ON, play the sound directly within this click
    if (!useSound) {
      soundRef.current
        .play()
        .catch(err => console.error("Audio play blocked or failed:", err));
      setCurrentNotification("soundon")
    } else {
      // If turning OFF, you could stop or pause the sound
      soundRef.current.pause();
      soundRef.current.currentTime = 0;
    }
  };


  return (
    loading ? <LoadingScreen recoveryActive={false} needsManualReload={needsManualReload} onManualReload={reloadNow} /> : (
      <div className={`page-map page-map-${trailid}`}>
        <LoadingClouds maploaded={maploaded} />
        <Map
          ref={mapref}
          initialViewState={viewport}
          style={{ position: 'fixed', width: '100vw', height: '100vh', height: '100dvh', backgroundColor: activeMapStyle === "satellite" ? "#14330f" : "#e4efcc" }}
          mapStyle={`https://api.maptiler.com/maps/${activeMapStyle}/style.json?key=${process.env.REACT_APP_MAP_KEY}`}
          onLoad={() => initialzoom()}
          onError={handleMapError}
        >
          {stationRadiusGeoJson &&
            <Source id="station-unlock-radius" type="geojson" data={stationRadiusGeoJson}>
              <Layer {...stationRadiusFillLayer} />
              <Layer {...stationRadiusLineLayer} />
            </Source>
          }

          {geojson &&
            <Source type="geojson" data={geojson}>
              <Layer {...lineStyle} />
            </Source>
          }

          {
            data.pois.map((obj, index) => {
              return (<Marker key={"poi-" + index} longitude={obj.long} latitude={obj.lat} anchor="center" onClick={() => toggletooltip(index)}><PoiDot type={obj.type} /></Marker>)
            })
          }

          {currentpoi > -1 ? (
            <Marker longitude={data.pois[currentpoi].long} latitude={data.pois[currentpoi].lat} anchor="bottom" offset={[0, -32]} style={{zIndex: poiTooltipZIndex}}>
              <div className='maptooltip'>
                {!data.pois[currentpoi].title && translate("poi_" + data.pois[currentpoi].type, data.language)}
                {data.pois[currentpoi].title && <p className='tooltipheadline'>{data.pois[currentpoi].title}</p>}
                {data.pois[currentpoi].description && <p className='tooltipdescription'>{data.pois[currentpoi].description}</p>}
              </div>
            </Marker>
          ) : null}

          {/*!collectbadgemode && */
            data.stations.map((obj, index) => {
              const z = stationZ[index] ?? 1;
              const stationDistance = stationdistances[index];
              const hasStationDistance = Number.isFinite(stationDistance);
              return (<Marker key={"marker-" + index} longitude={obj.long} latitude={obj.lat} anchor="bottom" onClick={() => togglestation(index) } style={{zIndex: z}}>
                <div className={`stationmarker ${!obj.done && hasStationDistance && stationDistance <= STATION_UNLOCK_RADIUS_METERS && "stationmarkeractive"}`}>
                  {(!obj.done && hasStationDistance) && <div className={`stationbubble ${(stationopen && currentstation === index) && "stationbubble-active"}`}>{formatDistance(stationDistance)}</div>}
                  {obj.done && <div className='stationcheckmark' style={{ width: 24, height: 24 }}><img src={checkmark} style={{ width: 16 }} /></div>}
                  <img src={markerbg} className='markerbg' />
                  <StationImage image={obj.image} style={{ width: 51, height: 51, position: 'absolute', top: 7 }} />
                </div>
              </Marker>)
            })
          }

          {currentposition &&
            <Marker onClick={() => flytoCurrentPosition()} key={"currentposition"} longitude={currentposition[1]} latitude={currentposition[0]} anchor="center">
              <PositionDot orientation={orientationAngle} />
            </Marker>
          }

          {/*
            collectbadgemode && 
            <Marker key={"badge"} longitude={badgePosition[1]} latitude={badgePosition[0]} anchor="center" >
                <div className={`stationmarker stationmarkerbadge`} onClick={() => (currentposition && badgePosition) && (calculateDistance(currentposition[0], currentposition[1], badgePosition[0], badgePosition[1]) <= 20) ? navigate(`/${regionid}/success/${trailid}`) : null}>
                  {getBadgeTooltip()}
                  <Badge img={`${process.env.REACT_APP_CONTENT_URL}${regionid}/${trailid}/badge.png`} active={true} />
                </div>
            </Marker>
          */}

        </Map>


        <div className={`stationpopupcontainer ${stationopen ? null : "stationpopupcontainerclosed"}`}>
          <div className='stationpopup'>
            <div className='stationpopupcloseicon clickable' onClick={() => setstationopen(false)}><img src={closeicon} /></div>
            <StationImage image={data.stations[currentstation]?.image} style={{ width: 56, height: 56, position: 'absolute', top: -30, border: "3px solid #fff", boxShadow: "0px 6px 8px #0003" }} />
            <p>{data.stations[currentstation]?.title}</p>
            {getStationLocationHint()}
            {getStationButton()}
          </div>
        </div>

        {/*<div className='mapbuttonbadge homebutton' onClick={() => navigate(`/${regionid}`)} style={{opacity: stationopen ? 0 : 1}}><img src={homeicon} /></div>*/}

        <div className='closebutton' onClick={() => navigate(`/${regionid}`, { state: { trail: trailid } })}><img src={closeiconwhite} /></div>



        {/*<div className='mapbuttonbadge timebadge' style={{opacity: stationopen ? 0 : 1}}><img src={timericon} />{"04:12"}</div>*/}

        <div onClick={() => setstationprogressmodalopen(true)}><MapProgress total={data.stations.length} done={data?.stations?.filter(station => station.done).length} points={253} /></div>




        <div className={`maprightbuttons mapvisible ${(stationopen || bigNotification) ? "maphidden" : ""}`}>
          <div className='maprightbutton clickable' onClick={() => handleToggleSound() /*setCurrentNotification("soundon")*/} ><img src={useSound ? icon_bell_on : icon_bell_off} /></div>
          <div className='maprightbutton clickable' onClick={() => handleToggleMapStyle()} ><img src={mapstyleicon} /></div>
          {currentposition &&
            <div className='maprightbutton clickable' onClick={() => flytoCurrentPosition()} ><img src={locationicon} /></div>
          }


        </div>

        {
          bigNotification && <BigNotification template={bigNotification} lang={data.language} onButtonClick={(x, y) => handlenotificationclick(x, y)} />
        }

        <NotificationProvider lang={data.language || "en"} notification={currentNotification} onRemove={() => setCurrentNotification(null)} onButtonClick={(x, y) => handlenotificationclick(x, y)} stationopen={stationopen} />

        <ModalStationProgress stations={data.stations} open={stationprogressmodalopen} onClose={() => setstationprogressmodalopen(false)} onSelect={(x) => togglestation(x)} total={data.stations.length} done={data?.stations?.filter(station => station.done).length} />

        <ModalLocationInfo open={locationinfomodalopen} onClose={() => setlocationinfomodalopen(false)} lang={data.language || "en"} />


        <div id='fancyfadeout'></div>
      </div>
    )
  );
}

export default MapNavigation;
